import React, { useState, Fragment, useEffect } from "react";
import { Transition, Dialog } from "@headlessui/react";
import NavMobile from "shared/Navigation/NavMobile";
import { useLocation, useNavigate } from "react-router-dom";
import menudot from "images/logos/lokalai/menudot.svg";
import {
  AdjustmentsHorizontalIcon,
  Bars3Icon,
  ChevronDownIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { Sling as Hamburger } from "hamburger-react";
import Avatar from "shared/Avatar/Avatar";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "redux/store";

export interface MenuBarProps {
  className?: string;
  iconClassName?: string;
}
const MenuBar: React.FC<MenuBarProps> = ({
  className = "p-2.5 text-neutral-700 dark:text-neutral-300 ",
  iconClassName = "h-7 w-7 fill-black text-redlight",
}) => {
  const [isVisable, setIsVisable] = useState(false);

  const location = useLocation();

  useEffect(() => {
    setIsVisable(false);
  }, [location]);

  const [isVisible, setIsVisible] = useState(false);

  const handleOpenMenu = () => setIsVisable(true);
  const handleCloseMenu = () => setIsVisable(false);

  const renderContent = () => {
    return (
      <Transition appear show={isVisable} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50 overflow-hidden"
          onClose={handleCloseMenu}
        >
          <Transition.Child
            as={Fragment}
            enter=" duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave=" duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-neutral-900 bg-opacity-50" />
          </Transition.Child>
          <div className="fixed inset-0">
            <div className="flex justify-end min-h-full ">
              <Transition.Child
                as={Fragment}
                enter="transition duration-100 transform"
                enterFrom="opacity-0 translate-x-56"
                enterTo="opacity-100 translate-x-0"
                leave="transition duration-150 transform"
                leaveFrom="opacity-100 translate-x-0"
                leaveTo="opacity-0 translate-x-56"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden transition-all ">
                  {/* show menu items in mobile  */}
                  <NavMobile onClickClose={handleCloseMenu} />
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    );
  };

  const user = useSelector((state: RootState) => state.auth.user);

  return (
    <>
      <button onClick={handleOpenMenu}>
        {user ? (
          <div
            className={`flex items-center gap-2 border border-border px-2 py-1 rounded-full transition `}
          >
            <Avatar
              sizeClass="w-8 h-8 sm:w-9 sm:h-9 "
              imgUrl={user.photo}
              hasChecked={user.isVerified === true}
            />
            <AdjustmentsHorizontalIcon className={iconClassName} />
          </div>
        ) : (
          <Bars3Icon className={iconClassName} />
        )}
      </button>

      {renderContent()}
    </>
  );
};

export default MenuBar;
